export default __webpack_public_path__ + "static/0284-7233140cd31821787438f5166baa09e3.png";